//import axios from "axios";

export default {
  namespaced: true,
  state: {
    isLoading: false,
    showAlert: false,
    alertText: "",
  },
  mutations: {
    is_loading(state, payload) {
      state.isLoading = payload;
    },
    show_alert(state, payload) {
      state.showAlert = payload;
    },
    alert_text(state, payload) {
      state.alertText = payload;
    },
  },
  actions: {},
  getters: {
    isLoading: (state) => state.isLoading,
    showAlert: (state) => state.showAlert,
    alertText: (state) => state.alertText,
  },
};
